function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { GroupingIndicator } from '../drag/GroupingIndicator';
import { messages, groupPanelEmpty as messageKey } from './../messages';
import { VueComponent } from '@progress/kendo-vue-common';
import Component from 'vue-class-component';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
/**
 * @hidden
 */

var GroupPanel =
/** @class */
function (_super) {
  __extends(GroupPanel, _super);

  function GroupPanel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GroupPanel.prototype.pressHandler = function (event, element) {
    this.$emit('pressHandler', event, element);
  };

  GroupPanel.prototype.dragHandler = function (event, element) {
    this.$emit('dragHandler', event, element);
  };

  GroupPanel.prototype.releaseHandler = function (event) {
    this.$emit('releaseHandler', event);
  };

  GroupPanel.prototype.onGroupRemove = function (event, index) {
    var newGroups = this.$props.group.slice();
    newGroups.splice(index, 1);
    this.$emit('groupChange', newGroups, event);
  };

  GroupPanel.prototype.onGroupSortChange = function (event, index, groupDesc, dir) {
    var group = Object.assign({}, groupDesc, {
      dir: dir
    });
    var newGroups = this.$props.group.slice();
    newGroups.splice(index, 1, group);
    this.$emit('groupChange', newGroups, event);
  }; // @ts-ignore


  GroupPanel.prototype.render = function (h) {
    var _this = this;

    var groupsProp = this.$props.group || [];
    var groups = groupsProp.map(function (groupDesc, index) {
      return h(GroupingIndicator, {
        key: index,
        attrs: {
          dir: groupDesc.dir || 'asc',
          title: _this.$props.resolveTitle(groupDesc.field)
        },
        on: {
          "remove": function remove(event) {
            return _this.onGroupRemove(event, index);
          },
          "sortChange": function sortChange(event, dir) {
            _this.onGroupSortChange(event, index, groupDesc, dir);
          },
          "press": _this.pressHandler,
          "drag": _this.dragHandler,
          "release": _this.releaseHandler
        }
      });
    });
    return h("div", {
      "class": "k-grouping-header k-grouping-header-flex"
    }, [groups, h("div", {
      "class": "k-indicator-container"
    }, [!groups.length && provideLocalizationService(this).toLanguageString(messageKey, messages[messageKey])])]);
  };

  GroupPanel = __decorate([Component({
    props: {
      group: Array,
      resolveTitle: Function
    },
    inject: {
      kendoLocalizationService: {
        default: null
      }
    }
  })], GroupPanel);
  return GroupPanel;
}(VueComponent);

export { GroupPanel };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-vue-grid/dist/es/header/GroupPanel.js
// module id = null
// module chunks = 